import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { getFundsComparisonPath } from './paths';
export var getPathComparison = function getPathComparison(theme, productType, products) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var contextString = context.length ? "&".concat(context.map(function (cont) {
    return "".concat(cont.id, "=").concat(cont.model.alias);
  }).join('&')) : '';
  var isFunds = productType.category === 'iic';
  var idsProducts = isFunds ? products.map(function (item) {
    return item.isin;
  }) : products.map(function (item) {
    return item.id;
  });
  if (isFunds) {
    return "".concat(getFundsComparisonPath(theme, productType), "#?products=").concat(idsProducts.join(',')).concat(contextString);
  }
  return "/".concat(productType.slug, "/comparador#?products=").concat(idsProducts.join(',')).concat(contextString);
};